import { render, staticRenderFns } from "./kcvideo.vue?vue&type=template&id=1a0610e8&scoped=true&"
import script from "./kcvideo.vue?vue&type=script&lang=js&"
export * from "./kcvideo.vue?vue&type=script&lang=js&"
import style0 from "./kcvideo.vue?vue&type=style&index=0&id=1a0610e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0610e8",
  null
  
)

export default component.exports